import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

//create action
export const createEmployee = createAsyncThunk(
  "createEmployee",
  async ({ data, form, history }) => {
    try{
    const token = localStorage.getItem("auth_token");
        const config = {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Access-Control-Allow-Origin": '*',
                "Content-Type": "application/json",
                "Accept": "application/json",
            }
        };
    const response = await axiosHttp.post(
      `employee/create`,
      data,
      config
    );

    form.resetFields();
    message.success("Employee successfully created!");
    history("/app/employee");
    return response.data;
    }catch(error){
      message.error(error.response.data.message);
    
    }
  }
);

const employeeCreateSlice = createSlice({
  name: "employeeCreate",
  initialState: {
    isLoading: false,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(createEmployee.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(createEmployee.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(createEmployee.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default employeeCreateSlice.reducer;